<template>
    <div class="d-flex" 
        :class="item.url_midia_colaboracao && !isFullScreen ? 'mb-12'
            : !isFullScreen ? 'mb-10' : ''"  
        :key="item.id_colaboracao"
    >
    <template v-if="!isFullScreen">
        <div class="imgBox d-flex align-center justify-center">
            <v-img :src="tarjaImgPath" max-width="80%"></v-img>
        </div>
        <div class="hashtag">
            <span class="text-h4">#TroféuPorchat</span>
        </div>
        <div class="content d-flex" :key="screenWidth">
            <v-avatar class="mr-2" :size="avatarSize">
                <v-img :src="item.url_avatar_colaborador" alt="avatar colaborador" cover />
            </v-avatar>
            <div class="ml-2 d-flex flex-column" style="width: 100%;">
                <div class="d-flex align-center">
                    <h5 class="font-weight-black black--text text-h4 mr-1 user">
                        {{ item.dsc_nome_colaborador }}
                    </h5>
                    <v-icon 
                        v-if="item.flg_colaborador_verificado === true" 
                        size="medium"
                        color="#009DF7"
                        class="mr-1" 
                    >
                        mdi-check-decagram
                    </v-icon>
                    <h5 class="font-weight-black grey--text text--lighten-1 text-h5 ml-1 username">
                        {{ item.dsc_colaborador_user }}
                    </h5>
                </div>
                <div
                    v-html="colabText"
                    class="black--text font-weight-bold bodyText"
                    :style="{'lineHeight': lineHeight, 'fontSize': bodyTextSize}"
                >
                </div>
                <footer style="width: 100%;" class="d-flex align-self-end justify-end">
                    <span 
                        class="align-self-end black--text font-weight-bold text-h5"
                    >
                        {{ item.dat_colaboracao | twitterData }}
                    </span>
                </footer>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="fullScreenContent">
            <header class="d-flex align-center my-2 ml-6" style="max-height: 120px;">
                <v-avatar class="mr-4" size="110">
                    <v-img :src="item.url_avatar_colaborador" alt="avatar colaborador" cover />
                </v-avatar>
                <div class="d-flex ml-2">
                    <h5 class="font-weight-black black--text text-h4 mr-1">
                        {{ item.dsc_nome_colaborador }}
                    </h5>
                    <v-icon 
                        v-if="item.flg_colaborador_verificado === true" 
                        size="x-large"
                        color="#009DF7"
                        class="mr-1 align-start mt-2" 
                    >
                        mdi-check-decagram
                    </v-icon>
                    <h5 class="font-weight-black grey--text text--lighten-1 text-h5 ml-1 mt-1">
                        {{ item.dsc_colaborador_user }}
                    </h5>
                </div>
            </header>
            <section class="d-flex flex-column align-center" :class="item.url_midia_colaboracao ? '' : 'mt-4'">
                <v-img v-if="item.url_midia_colaboracao" class="mb-2" :src="item.url_midia_colaboracao" contain max-width="50%" max-height="280px"/>
                <div
                    v-if="item.dsc_texto_colaboracao"
                    v-html="colabText"
                    class="px-6 black--text font-weight-bold bodyText align-self-start"
                    :style=" item.url_midia_colaboracao ? {'lineHeight': lineHeight, 'fontSize': bodyTextSize} : 
                        {'lineHeight': lineHeightFullScreen, 'fontSize': bodyTextSizeFullSreen}"
                >
                </div>
            </section>
            <footer style="width: 100%;" class="d-flex align-self-end justify-space-between justify-self-end">
                <h5 class="black--text text-h4 font-weight-bold">#TroféuPorchat</h5>
                <span 
                    class="align-self-end black--text font-weight-bold text-h4"
                >
                    {{ item.dat_colaboracao | twitterData }}
                </span>
            </footer>
        </div>
    </template>
    </div>
</template>

<script>
import { monthNumberToNameObject } from "@/utils/dateUtils";
export default {
    props: {
        item: Object,
        posicaoCard: String,
        isFullScreen: Boolean,
        hideUserInfo: Boolean,
        flg_exibir_uf: Boolean,
    },
    data() {
        return {
            tarjaImgPath: require("../../assets/tarjas/tj-twitter-qheep.png"),
        }
    },
    filters: {
        twitterData(data_string) {
            const [ day, month, year ] = new Date(data_string).toLocaleDateString().split("/")
            const [ hour, minutes, ] = new Date(data_string).toLocaleTimeString().split(":")
            const period = hour >= 12 && hour <= 23 ? 'PM' : 'AM'
            const formated_hour = period === 'PM' && hour > 12 ? Number(hour) - 12 : hour
            const date = `${formated_hour}:${minutes} ${period} · ${day} de ${monthNumberToNameObject[month].slice(0, 3).toLowerCase()} de ${year}`
            return date
        },
    },
    computed: {
        colabText() {
            return this.formatText(this.item.dsc_texto_colaboracao);
        },
        renderMode() {
            if(this.isFullScreen) {
                return 'fullscreen'
            }
            return 'text'
        },
        screenWidth() {
            return window.innerWidth;
        },
        bodyTextSize() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            let size;
            if (window.innerWidth === 1366) {
                size = numChars > 0 && numChars <= 40 ? '2rem'
                         : numChars > 40 && numChars <= 80 ? '1.6rem'
                         : numChars > 80 && numChars <= 120 ? '1.25rem'
                         : numChars > 120 && numChars <= 160 ? '1.15rem'
                         : numChars > 160 && numChars <= 200 ? '1.1rem'
                         : numChars > 200 && numChars <= 240 ? '.95rem'
                         : numChars > 240 && numChars <= 280 ? '.85rem'
                         : '1.4rem'
            } else {
                size = numChars > 0 && numChars <= 40 ? '2rem'
                         : numChars > 40 && numChars <= 80 ? '1.9rem'
                         : numChars > 80 && numChars <= 120 ? '1.8rem'
                         : numChars > 120 && numChars <= 160 ? '1.7rem'
                         : numChars > 160 && numChars <= 200 ? '1.6rem'
                         : numChars > 200 && numChars <= 240 ? '1.5rem'
                         : numChars > 240 && numChars <= 280 ? '1.35rem'
                         : '1.4rem'
            }
            return size;
        },
        lineHeight() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            let lineHeight;
            if(window.innerWidth === 1366) {
                lineHeight = numChars > 0 && numChars <= 40 ? '2rem'
                         : numChars > 40 && numChars <= 80 ? '1.8rem'
                         : numChars > 80 && numChars <= 120 ? '1.4rem'
                         : numChars > 120 && numChars <= 160 ? '1.15rem'
                         : numChars > 160 && numChars <= 200 ? '1.1rem'
                         : numChars > 200 && numChars <= 240 ? '1.1rem'
                         : numChars > 240 && numChars <= 280 ? '1rem'
                         : '1.5rem'
            } else {
                lineHeight = numChars > 0 && numChars <= 40 ? '2.5rem'
                         : numChars > 40 && numChars <= 80 ? '2.3rem'
                         : numChars > 80 && numChars <= 120 ? '2.2rem'
                         : numChars > 120 && numChars <= 160 ? '1.55rem'
                         : numChars > 160 && numChars <= 200 ? '1.6rem'
                         : numChars > 200 && numChars <= 240 ? '1.6rem'
                         : numChars > 240 && numChars <= 280 ? '1.4rem'
                         : '1.5rem'
            }
            return lineHeight
        },
        bodyTextSizeFullSreen() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const size = numChars > 0 & numChars <= 40 ? '3.8rem'
                : numChars > 40 && numChars <= 80 ? '3.5rem'
                    : numChars > 80 && numChars <= 120 ? '3.2rem'
                        : numChars > 120 && numChars <= 160 ? '3rem'
                            : numChars > 160 && numChars <= 200 ? '2.8rem'
                                : numChars > 200 && numChars <= 240 ? '2.7rem'
                                    : numChars > 240 && numChars <= 280 ? '2.6rem'
                                        : '1.5rem'
            return size;
        },
        lineHeightFullScreen() {
            const numChars = this.item.dsc_texto_colaboracao.trim().length;
            const lineHeight = numChars > 0 & numChars <= 40 ? '3.8rem'
                : numChars > 40 && numChars <= 80 ? '3.5rem'
                    : numChars > 80 && numChars <= 120 ? '3.2rem'
                        : numChars > 120 && numChars <= 160 ? '3rem'
                            : numChars > 160 && numChars <= 200 ? '2.9rem'
                                : numChars > 200 && numChars <= 240 ? '2.8rem'
                                    : numChars > 240 && numChars <= 280 ? '2.6rem'
                                        : '1.5rem'

            return lineHeight
        },

        avatarSize() {
            if(window.innerWidth === 1366) {
                return 64
            }
            return 90
        }
    },
    methods: {
        formatText(text) {
            const words = text.replaceAll("\n", " ").split(" ");
            const hashtagRe = new RegExp("(?<!\\S)#\\S+|\\S+#(?!\\S)")
            const twitterUserRe = new RegExp("^@[a-zA-Z-à-ú0-9_]{0,15}.$");
            const newWords = words.map((word) => {
                let result = word
                const wordHasHashtag = hashtagRe.test(word)
                const wordHasUser = twitterUserRe.test(word)
                if(wordHasHashtag || wordHasUser) {
                    const ponctuationRe = new RegExp("\\p{P}+$", "umg")
                    if(ponctuationRe.test(word)) {
                        result = `<span class='userOrHashtag'>${word.slice(0, word.length - 1)}</span>${word.slice(-1)}`;
                    } else {
                        result = `<span class='userOrHashtag'>${word}</span>`
                    }
                }
                return result;
            })
            return newWords.join(" ").trim()
        },
    },
}
</script>

<style lang="scss" scoped>

.imgBox {
    width: 100%;
}
.hashtag {
    position: absolute;
    bottom: 300px;
    left: 380px;
    span {
        color: white;
        font-weight: 400;
    }
}

.content {
    width: 1100px;
    position: absolute;
    bottom: 120px;
    left: 380px;
}

.fullScreenContent {
    display: grid !important;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
    position: absolute;
    width: 1050px;
    height: 520px;
    bottom: 280px;
    left: 470px;

    section {
        max-width: 1000px;
        max-height: 450px;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1366px){

    .imgBox {
        width: 80%;
    }
    .hashtag {
        bottom: 215px;
        left: 260px;

        span {
            font-size: 1.6rem !important;
        }
    }

    .content {
        width: 720px;
        bottom: 80px;
        left: 240px;

        // .bodyText {
        //     font-size: 1.4rem !important;
        //     line-height: 1.3rem !important;
        // }

        footer > span {
            font-size: 1.1rem !important;
        }
    }

    .v-avatar {
        margin-top: 10px !important;
    }

    .user {
        font-size: 1.4rem !important;
    }
    .username {
        font-size: 1.3rem !important;
    }
}

</style>